import React from "react";
import config from "./aws-exports.old";

import { Authenticator, Greetings, SignIn } from "aws-amplify-react";

import CustomSignIn from "./CustomSignIn";
import App from "./App";
import AddToClio from "./AddToClio";

const AppWithAuth = (props) => {
  return (
    <Authenticator amplifyConfig={config} hide={[Greetings, SignIn]}>
      <CustomSignIn
        origin={
          window.location.href === "https://app.report-zone.com/home/addToClio" ||
          window.location.href === "http://localhost:3000/home/addToClio"
            ? "addToClio"
            : "aws"
        }
      />
      {window.location.href === "https://app.report-zone.com/home/addToClio" ||
      window.location.href === "http://localhost:3000/home/addToClio" ? (
        <AddToClio />
      ) : (
        <App />
      )}
    </Authenticator>
  );
};

export default AppWithAuth;
